import { isAllowedTalkOrigin, talkBrand, TALK_ORIGINS } from "./brand";

export function normalizeRoomCode(value: string): string {
  const compact = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
  if (compact.length <= 4) return compact;
  if (compact.length <= 8) return `${compact.slice(0, 4)}-${compact.slice(4)}`;
  return `${compact.slice(0, 4)}-${compact.slice(4, 8)}-${compact.slice(8)}`;
}

export function roomCodeFromJoinInput(value: string, currentOrigin = talkBrand.origin): string {
  const input = value.trim();
  if (!input) return "";
  if (/^[a-z0-9\s-]+$/i.test(input)) return normalizeRoomCode(input);

  try {
    const current = new URL(currentOrigin);
    const url = new URL(input, new URL("/join", current));
    const allowedOrigins = new Set([current.origin, ...TALK_ORIGINS]);
    if (!allowedOrigins.has(url.origin)) return "";
    if (url.pathname.replace(/\/+$/, "") !== "/join") return "";
    const fragment = new URLSearchParams(url.hash.replace(/^#/, ""));
    return normalizeRoomCode(fragment.get("code") ?? "");
  } catch {
    return "";
  }
}

export function isCompleteRoomCode(value: string): boolean {
  return normalizeRoomCode(value).replaceAll("-", "").length === 12;
}

export function roomInviteURL(code: string, origin = talkBrand.origin): string {
  const normalized = normalizeRoomCode(code);
  if (!isCompleteRoomCode(normalized)) throw new Error("A complete room code is required.");
  const url = new URL("/join", origin);
  url.hash = new URLSearchParams({ code: normalized }).toString();
  return url.toString();
}

export function safeReturnPath(value: unknown, fallback = "/"): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) return fallback;
  try {
    const url = new URL(value, talkBrand.origin);
    if (!isAllowedTalkOrigin(url.origin)) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
